// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILegalInfoFieldSchema {
  /** Название поля **/
  title: string;
  /** Тип поля **/
  type: EType;
  /** Значение поля **/
  value: string;
}

export enum EType {
  /** Ссылка **/
  'Link' = 'link',
  /** Простой текст **/
  'Text' = 'text',
}
